import React from 'react';

const TextareaCustom = (props) => {
  return (
    <textarea
      {...props}
      onChange={props.onChange}
      placeholder={props.placeholder}
      maxLength={200}
      style={{width: '100%', height: 20, border: 'none', resize: 'vertical' }}
    />
  );
};

export default TextareaCustom;
